const strings = {
  enterEmailId: "Email",
  enterEmail: "Enter email-id",
  enterFullName: "Full name",
  selectGender: "Select your gender",
  enterPhoneNumber: "Enter your phone number",
  enterUserName: "Username",
  selectRole: "Select/Enter your role",
  enterDateOfBirth: "Date of birth",
  enterEmailOrUserName: "Mobile/Username",
  enterECID : 'Enter ECID',
  countryCode: "+91",
  selectWhatAmusesYou: "What interests you?",
  postTitle: "Post Title (Optional)",
  descrption: "Description (Optional)",
  projectName: "Collab name*",
  projectCategory: "Collab category*",
  ownerShipType: "Copyright Ownership",
  revenueShareType: "Future Revenue Split*",
  startDate: "Start Date*",
  endDate: "End Date",
  enterAddressManually: "Enter full address manually",
  share: "Share %",
  fullName: "fullName",
  gender: "gender",
  agreementText: "By signing up, you agree to our",
  comma: ",",
  terms: "Terms",
  privayPolicy: "Privacy Policy",
  cookiesPolicy: "Cookies Policy",
  phoneNumber: "phoneNumber",
  dateOfBirth: "dateOfBirth",
  userName: "userName",
  roles: "roles",
  uploadTooltipTitle: "New Post/Upload",
  userAlreadyExist: "User Already Exist, Please login",
  enterTheCodeSentTo: "Enter the OTP sent to ",
  thanksOneLastOneStep: "Thanks! One last step",
  letsPersonalizeYourProfile: "Let's personalize your profile",
  thatsGreatName: ", that's a nice name!",
  enterTheOTPsentto: "Enter the OTP sent to",
  space: " ",
  greetingsFromSkeron: "Greetings from Sekeron",
  whatsYourName: "What’s your name?",
  others: "others",
  createCustomSkill: "Create Custom Skill",
  login: "Login",
  countrycode: "Enter your Country Code",
  uploadedFilesWillBeShownHere: "Uploaded files will be shown here",
  createPost: "Create post",
  dragAndDrop: "Drag & Drop Files here",
  createAPost: "Create a post",
  uploadYourDesires: "Upload your desired media using the tools below",
  previewPost: "Preview Post",
  publishPost: "Publish Post",
  backToEditPost: "Back to edit Post",
  mediaGallery: "Media Gallery",
  description: "Description",
  reply: "Reply",
  hideReplies: "Hide Replies",
  replies: "Replies",
  comments: "Comments",
  post: "Post",
  addAComment: "Add a Comment...",
  addAReply: "Add a Reply as",
  reorderingContents: "Reordering contents",
  selectColor: "Select background colour of your post",
  publishPostSuccessMessage: "Your Post has been published successfully.",
  cancel: "Cancel",
  reorderMedia: "Re-Order Media",
  projectId: "Collab ID: ",
  and: "and",
  requiredArtist: "Required artists",
  collaboratorDisclaimer:
    "Disclaimer: If you have different requirements from the same kind of skill, you can add a separate skill of the same name and add separate requirements in that.",
  addArtistWarningMessage:
    "If you dont add anyone, then the space will be open for people in sekeron platform to apply",
  collaborationTerms: "Collaboration Terms",
  termsAndConditionsInfo:
    "Please go through all the documents thoroughly before agreeing",
  agreeToTermsAndConditions: "I agree to all of the above documents",
  artistType: "Artist Type",
  projectType: "Collab Type:",
  chooseCoverImage: "Choose Collab cover image",
  youmightLooseChanges: "You might lose any changes you’ve made on this page.",
  projectPublishedSuccefully: "Your Collab has been published successfully.",
  thisWillSendInvitesToAllArtists:
    "This will send Invites to all the added artists?",
  areYouSureYouWantToClearTheSelectedItems:
    "Are you sure you want to clear the selected media?",
  areYouSureYouWantToDiscardChanges: "Are you sure?",
  sendCodeTo: "Send Code to",
  projectGuidelines: "Collab Guidelines ",
  inviteYourFriends: "Invite your friends",
  ifYouWantToIncreaseNumberOfSpots:
    "If you want to increase the number of spots available, you can edit the Collab",
  youCannotInviteMoreThanUnfilledSpots:
    "You cannot invite more than unfilled spots.",
  you: "You",
  projectOwner: "Collab owner",
  otherCollaborators: "Other collaborators",
  reNegotiate: "Re-Negotiate",
  enterThePercentageYouWishToShare: "Enter the percentage you wish to share ",
  enterPercentage: "Enter Percentage",
  sharePercentage: "Share % left to distribute:",
  successfulllyVerified: "You have succesfully verified the account",
  letsGetStarted: "Let's get you started",
  edit: " Edit",
  loginHere: " LOGIN HERE",
  joinedAlready: "Joined Already?",
  haveAccount: "Have an account?",
  signIN: "Sign In",
  resendOtpIn: "Resend OTP in",
  resendOtp: "Resend OTP",
  or: "Or",
  continue: "Continue",
  verify: "Verify",
  takeMeToHome: "Take me to my Home",
  donHaveAnAccount: "Don't have an account?",
  signUpHere: "Sign Up",
  sendOtp: "Send OTP",
  getStarted: "Let's get started",
  uploadFile: "Upload File",
  clearAll: "Clear All",
  next: "Next",
  addMoreMedia: "Add More Media",
  done: "Done",
  save: "Save",
  reorder: "Reorder",
  addNewCanvas: "Add a new text canvas",
  locateOnMap: "Locate on map",
  reportProject: "Report Collab",
  createProject: "Create a Collab",
  previewProject: "Preview Collab",
  addTerm: "Add another term",
  startProjectCreation: "Start Collab Creation",
  previewProjectNow: "Preview Collab Now",
  cancelProjectCreation: "Cancel Collab creation?",
  no: "No",
  yes: "Yes",
  publishProject: "Publish Collab",
  backToEditProject: "Back to editing",
  discard: "Discard",
  previous: "Previous",
  apply: "Apply",
  askToCollaborate: "Ask to Collaborate",
  inviteMore: "Invite More",
  invite: "Invite",
  saveAndNext: "Save & Next",
  initiateNewMeeting: "Initiate new meeting",
  createNewTask: "Create New Task",
  reject: "Reject",
  enterValidEmail: "Please enter a valid Email ID",
  pleaseEnterEmail: "Please enter an email",
  pleaseEnterFullname: "Please enter an fullname",
  pleaseSelectGener: "Please select an gender",
  enterValidPhoneNumber: "Please enter a valid phone number",
  pleaseEnterPhoneNumber: "Please enter an phone number",
  pleaseSelectDateofBirth: "Please select an date of birth",
  pleaseEnterUsername: "Please enter an username",
  userNameExist: "Username is unavailable",
  pleaseSelectRole: "Please select an role",
  enterProjectName: "please enter Collab name",
  enterCategory: "please enter category of the Collab",
  selectOwnershipType: "please select ownership type",
  selectRevenueShareType: "please select revenue share type",
  selectStartDateOftheProject: "please select start date",
  email: "email",
  follow: "Follow",
  more: "...more",
  admire: "Like",
  comment: "Comment",
  viewPost: "View Post",
  report: "Report",
  trendingProjects: "Trending Collabs",
  seeAll: "SEE ALL",
  registerNow: "Register now!!",
  unfollow: "Unfollow",
  artistSuggestion: "Artist Suggestions",
  following: "Following",
  shareList: "Share List",
  writeMessage: "Write a message...",
  addedToFavourite: "Add to favorites",
  removedFromFavourite: "Remove from favorites",
  showLess: "Show less",
  projectSuggestions: "Collab Suggestions",
  uploadMedia: "Upload Media",
  uploadScreenShots: "You can upload screenshots,if you have any.",
  newPost: "New Post",
  new: "new",
  old: "old",
  admirations: "Likes",
  upload: "upload",
  audio: "audio",
  text: "text",
  message: "message",
  mutual: "Mutual",
  collabarated: "Collaborated",
  pleaseSelectThePostCategory: "Please select post category",
  newProject: "Start Collab",
  media: "Media",
  collaborators: "Collaborators",
  postCategory: "Post Category:",
  projectHighlights: "Collab highlights",
  rateColloborators: "Rate Collaborators",
  proceed: "Proceed",
  colloboratorDescription: "Write something about the collabrator",
  finishProject: "Finish Collab",
  shareYourExperience: "Share your experience",
  skip: "Skip >",
  submit: "Submit",
  finishedSuccessfully: "finished successfully.",
  dueDate: "Due Date",
  youHaveReportedSuccessfully:
    "Your report has been succesfully recorded against",
  sureYouWantReportPost: "Are you sure you want to report this post under ",
  remove: "Remove",
  saveChanges: "Save Changes",
  selectFromDevice: "Select From Device",
  profilePicture: "Profile Picture",
  coverPicture: "Cover Picture",
  retake: "Retake",
  removeProfilePicture: "Remove Profile Picture?",
  removeCoverPicture: "Remove Cover Picture?",
  useThisPicture: "Use This",
  editProfile: "Edit Profile",
  coverImage: "coverImage",
  profileImage: "profileImage",
  upcoming: "Upcoming",
  completed: "Completed",
  ongoing: "Ongoing",
  dropped: "Dropped",
  readNow: "Read now",
  viewAll: "View All",
  online: "ONLINE",
  attend: "Attend",
  moreLikeThis: "More Like this",
  applyFilters: "Apply Filters",
  youHaveAppliedForThisEvent: "You have applied for this event on ",
  payAnd: "Pay & ",
  areYoueighteenAndAbove: "Are you 18 and above?.",
  eventsQuestion: "Few questions to set you up for the event",
  join: "join",
  makePaymentOf: "Make payment of Rs. ",
  notifications: "Notifications",
  postNotificationMessage:
    "Your post related notifications will appear here, create your first post or explore now!",
  projectNotificationMessage:
    "Your collab related notifications will appear here, create your first collab or explore and collaborate now!",
  eventNotificationMessage:
    "Your events related notifications will appear here, create your first collab or explore and collaborate now!",
  topProjects: "Top Collabs",
  topBlogs: "Top Blogs",
  topPosts: "Top Posts",
  upComingEvents: "Upcoming Events",
  myDashboard: "My Dashboard",
  myProjects: "My Collabs",
  myEvents: "My Events",
  myCollaborations: "Joined Collabs",
  myCalender: "My Calender",
  photos: "Photos",
  videos: "Videos",
  scripts: "Scripts",
  audios: "Audios",
  clearPage: "Clear Page",
  deletePage: "Delete Page",
  sendImageToGroup: "Send image to group",
  switchToDarkMode: "Switch to dark mode",
  switchToLightMode: "Switch to light mode",
  collaboratorSettings: "Collaborator Settings",
  collaboratorsUpdates: "Collaborators Updates",
  projectCat: "Collab Category: ",
  copyRightOwnership: "Copyright Ownership",
  futureRevenueSplit: "Future Revenue Split: ",
  requiredArtists: "Required Artists",
  messageTheCreator: "Message the creator to negotiate terms",
  artists: "Artists",
  filterBy: "Filter by",
  Gender: "Gender",
  notificationRoute: "/notifications",
  followers: "Followers",
  bio: "Bio",
  skills: "Skills",
  educationalInfo: "Educational Info",
  location: "Location",
  socialMediaLinks: "Social Media Links",
  websiteLink: "Website link",
  instagramUrl: "Instagram",
  facebookUrl: "Facebook",
  pinterestUrl: "Pinterest",
  youtubeUrl: "Youtube",
  username: "User Name",
  name: "Name",
  websiteOrPortFolio: "Website / Portfolio URL",
  describeYourself: "Describe Yourself",
  addCollege: "Add College",
  highSchoolName: "High School Name",
  addAnyAdditionalInfo: "Add Any Additional Info",
  city: "City",
  country: "Country",
  instagram: "Instagram URL",
  facebook: "Facebook URL",
  pinterest: "Pinterest URL",
  youtube: "Youtube URL",
  favourites: "Favourites",
  locatedOnMap: "located on map",
  aboutToFinish: "You are about to finish this collab?",
  isThisProjectCompleted: "Is this Collab completed?",
  projectEndSuggestionMesssge: `We want to know if you have succesfully finished this collab,
   or are you closing the collab before finishing it. This information will help us serve
    you better in the future`,
  typeHere: "Type Here",
  howWasYourExperience: "How was your experience?",
  writeToUs: "Write to us",
  wantToReport: "What do you want to report?",
  whomYouWantToReport: "Whom you want to Report?",
  reportCollabarators: "Report Collabarators",
  reportList: "Report List",
  whoAreYouReportingPerson: "Why are you reporting this Person?",
  whyAreYouReportingProject: `Why are you reporting this Collab?`,
  reportingReason: `Your report is anonymous, except if you are reporting an itellecutal property infringement.
   If someone is in immediate danger, call local emergncy services don’t wait. `,
  reportWithMedia: "Report with Media",
  areYouSureYouWantToReport: "Are you sure you want to report",
  textAreaLabel: "Write to us about the reason why you are reporting",
  youCanUploadMedia: "You can upload screenshots,if you have any.",
  directMessages: "Direct Messages",
  projectMessages: "Collab Messages",
  hoursAgo: "Hours ago",
  typeMessage: "Type Message",
  firstChatMessage:
    "You don’t follow each other on sekeron You both follow Rafiq and 2 others",
  viewProfile: "View Profile",
  muteNotification: "Mute Notification",
  clearChat: "Clear Chat",
  emptyMessageSuggestiion: "Help & Keep sekeron  a supporting place",
  followSugestion:
    "Remember to follow our Community Guidlines and be respectful when messaging others for the first time.",
  profile: "Profile",
  project: "Collab",
  blog: "Blog",
  image: "Image",
  video: "Video",
  settings: "Settings",
  general: "General",
  help: "Help",
  reportAProblem: "Report a Problem",
  leaveFeedbackAboutSekeron:
    "Please only leave feedback about Sekeron and our features. Visit our helpcenter to learn more about reporting content posted. All reports are subject to our Terms of use. ",
  sendFeedbackOrSuggestions: "Send feedback or suggestions",
  legal: "Legal",
  helpCentre: "Help Centre",
  supportRequests: "Support Requests",
  faqs: "FAQ’s",
  popularCategories: "Popular Categories",
  profileSecurity: "Profile Security",
  loginCredentials: "Login credentials",
  loginActivity: "Login activity",
  deleteThisAccount: "Delete this account?",
  saveLoginInfo: "Save login info",
  sekeronWillRememberYourAccountInfo:
    "Sekeron will remember your account info for you on this device. you won’t need to enter it when you login again.",
  areYouSureYouWantDeleteAccount:
    "Are you sure you want to Delete this account?",
  areYouSureYouWantDeletePost: "Are you sure you want to Delete this post",
  logout: "Logout",
  areYouSureYouWantToLogout: "Are you sure you want to logout?",
  changeEmail: "Change Email",
  changeMobileNumber: "Change Mobile No.",
  congratulations: "Congratulations!",
  youHaveChangedYourEmailIdSuccessfully:
    "You have changed your email-id successfully",
  youHaveChangedYourPhoneNumSuccessfully:
    "You have changed your phone number successfully",
  isThisYou: "Is this you?",
  ifThisIsNotYou:
    "If this is not you then please logout as soon as possible as your account can be miss used.",
  wereYouLoggedinto: "Were you logged into",
  logoutOfAllDevices: "Logout of all devices",
  changeYourEmailidAndVerifyWithOtp:
    "Change your Mail-id. and verify with OTP.",
  changeYourPhoneNumberAndVerifyWithOtp:
    "Change your Phone Number, and verify with OTP.",
  artCulture: "Arts Culture",
  contents: "Contents",
  caseNumber: "case number: ",
  uploadedMedia: "Uploaded Media",
  postCategoryLabel: "Post Category*",
  owned: "Owned",
  newRequests: "New Requests",
  peopleCollaborated: "People collaborated",
  updates: "Updates",
  messageToCollaboratorForEqualSplit:
    "This collab is Equal Future Revenue Split which means that the % of share will be equally split between the collaborators of the collab",
  messageToCollaboratorForUnEqualSplit:
    "The collab Admin will let you know your % before accepting you in the collab5",
  percentageOffered: "Percentage Offered:  ",
  camera: "Camera",
  gallery: "Gallery",
  home: "Home",
  confirmLocation: "Confirm Location",
  selectProjectLocation: "Select Collab location",
  addressLine: "Address Line 1 *",
  landmark: "Landamark *",
  fetchingLocation: "Fetching location..",
  currentLocaton: "Current Location",
  usingGPS: "Using GPS",
  enterTaskTitle: "Please enter task title",
  enterTaskDescription: "Please enter description",
  pleaseEnterDueDate: "Please enter due date",
  addressError: "Address must be greater than 20 character.",
  thisWillBeTheLocation: "Collab Location Will be this",
  placeThePinAccurately: "Place the pin accurately on the map",
  enterDescription: "Enter Description(Optional)",
  estimatedRevenueShare: "Estimaed Revenue Share:",
  secondsAgo: "Seconds Ago",
  minutesAgo: "Minutes Ago",
  file: "file",
  youAreNoLongerAvailableIInThisGroup:
    "You are no longer available in this group.",
  showNotifications: "Show Notifications",
  clearMessageSuggestion: "Messages will only be removed from this device.",
  muteNotifications: "Mute Notifications",
  unMuteNotifications: "UnMute Notifications",
  meetingTitle: "Meeting Title",
  noRecordsFound:
    "We couldn't find any matches. Don't worry, there’s plenty more to explore!",

    //events
    eventId:"Event ID:"
};

export default strings;
